export const SET_USER = 'SET_USER'
export const SET_PARAMS = 'SET_PARAMS'
export const SET_APP_LOADED = 'SET_APP_LOADED'
export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR'
export const THERE_IS_UNSAVED_WORK = 'THERE_IS_UNSAVED_WORK'
export const THERE_IS_NOT_UNSAVED_WORK = 'THERE_IS_NOT_UNSAVED_WORK'
export const SET_ACTION_TO_HANDLE_UNSAVED_WORK = 'SET_ACTION_TO_HANDLE_UNSAVED_WORK'
export const OPEN_CONFIRM_ROUTE_CHANGE_DIALOG = 'OPEN_CONFIRM_ROUTE_CHANGE_DIALOG'
export const CLOSE_CONFIRM_ROUTE_CHANGE_DIALOG = 'CLOSE_CONFIRM_ROUTE_CHANGE_DIALOG'
